
import React, { useState, useEffect } from 'react';
import CommonLoader from '../../common/CommonLoader';
import TestProcessTable from './TestProcessTable';
import { GetTestProcesses } from '../../../services/TestProcessService';
import { NotificationManager } from 'react-notifications';

const TestProcesses = () => {
  const [loading, setLoading] = useState(false);
  const [testProcessesData, setTestProcessesData] = useState([]);
  const [testProcessesCount, setTestProcessesCount] = useState(0);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getClients();
  }, [page, rowsPerPage]);

  const getClients = async () => {
    try {
      setLoading(true);
      const response = await GetTestProcesses(page, rowsPerPage);
      setTestProcessesData(response.results);
      setTestProcessesCount(response.count);
    } catch (err) {
      NotificationManager.error('Error getting Test Processes. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  const onChangePageSettings = async (pageNumber, pageSize) => {
    setPage(pageNumber);
    setRowsPerPage(pageSize);
  };

  return (
    <div className="vlp-component-container">
      <span className="title">Test Process Configuration </span>
      <hr />
      <TestProcessTable clientsData={testProcessesData} count={testProcessesCount} onChange={onChangePageSettings} />
      <CommonLoader loading={loading} />
    </div>
  );
};

export default TestProcesses;

